module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-pyn.2cbd2ef0.png";